// extracted by mini-css-extract-plugin
export default {"wrapper":"components-Shared-Form-InputSelect-select__wrapper--gzzhz"};